<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select
        class="ng-select-fill project-input"
        [placeholder]="field.name"
        [formControl]="fc"
        [items]="filteredProjects"
        [selectableGroup]="false"
        [trackByFn]="trackByFn"
        [loading]="projectsLoading"
        [typeahead]="projectInput$"
        (change)="onSelection($event)"
        (focus)="projectFocus$.next()"
        bindValue="afas_project_id"
        groupBy="mainProject">
        <ng-template ng-label-tmp let-item="item">
            <b>{{ item.afas_project_id }}</b> {{ item.name }}
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <b>{{ item.afas_project_id }}</b> {{ item.name }}
        </ng-template>

        <ng-template ng-footer-tmp>
            <small>
                @if (resultsForCustomer) {
                    {{ filteredProjects.length }} projecten voor <b>{{ selectedCustomerName }}</b>
                } @else {
                    <b>Geen</b> projecten voor klant <b>{{ selectedCustomerName }}</b>
                }
            </small>
        </ng-template>
    </ng-select>

    @if (!fc.value || !(filteredProjects | byId: fc.value : 'afas_project_id')) {
        <mat-hint>{{ formData?.orginal?.afas_project_id }}</mat-hint>
    }

    <mat-error [control]="fc"></mat-error>
</div>
